<template>
  <div>
    <table class="table table-sm color mb-2">
      <caption class="caption table-caption">Add user</caption>
      <tbody>
        <tr>
          <th class="text-left font-weight-normal">User name:</th>
          <td class="text-right">
            <b-form-input id="userName" class="calculation-settings-input text-left" v-model="userName"></b-form-input>
          </td>
        </tr>
        <tr>
          <th class="text-left font-weight-normal">Password:</th>
          <td class="text-right">
            <b-form-group>
              <b-input-group>
                <b-form-input :type="userPasswordType" v-model="userPassword" required placeholder="Password" size="sm"></b-form-input>
                <b-input-group-append>
                  <b-button variant="info"
                    @mousedown="userPasswordType = 'text'"
                    @mouseup="userPasswordType = 'password'"
                    class="pwd-btn py-0">
                    <b-icon-eye-slash v-if="userPasswordType == 'password'"></b-icon-eye-slash>
                    <b-icon-eye-fill v-else></b-icon-eye-fill>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </td>
        </tr>
        <tr>
          <th class="text-left font-weight-normal">Confirm password:</th>
          <td class="text-right">
            <b-form-group>
              <b-input-group>
                <b-form-input :type="confirmationPasswordType" v-model="confirmPassword" required placeholder="Confirm password" size="sm"></b-form-input>
                <b-input-group-append>
                  <b-button variant="info"
                    @mousedown="confirmationPasswordType = 'text'"
                    @mouseup="confirmationPasswordType = 'password'"
                    class="pwd-btn py-0">
                    <b-icon-eye-slash v-if="confirmationPasswordType == 'password'"></b-icon-eye-slash>
                    <b-icon-eye-fill v-else></b-icon-eye-fill>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </td>
        </tr>
        <tr>
          <th class="text-left font-weight-normal">Roles:</th>
          <td class="text-right">
            <b-form-group>
              <b-form-checkbox-group v-model="selected" :options="roles">
              </b-form-checkbox-group>
            </b-form-group>
          </td>
        </tr>
      </tbody>
    </table>
    <b-row class="float-right">
      <b-col>
        <b-btn variant="info" v-on:click="addUser">Add user</b-btn>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import service from '../../services/HttpRequestService';

import { UserNotifications, withUINotification } from '../../hooks/UserNotifications';

export default {
  props: {
    roles: Array
  },
  data() {
    return {
      userName: '',
      userPassword: '',
      confirmPassword: '',
      userPasswordType: 'password',
      confirmationPasswordType: 'password',
      selected: []
    };
  },
  methods: {
    async addUser() {
      if (!this.areInputsCorrect()) {
        UserNotifications.Error('Please enter username and password').emit(this);
        return;
      }

      await withUINotification.bind(this)(async () => {
        await service.createUser(
          this.userName,
          this.userPassword,
          this.confirmPassword,
          this.selected
        );

        this.userName = '';
        this.userPassword = '';
        this.confirmPassword = '';
        this.selected = [];

        UserNotifications.UserChanged(user.Id).emit(this)
      },
      `Failed to create the user ${this.userName}.`,
      `The user ${this.userName} has been created successfully.`);
    },
    areInputsCorrect() {
      return this.userName.length > 0 && this.userPassword.length > 0;
    }
  }
};
</script>
